import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';

interface IInviteParams {
    organizationId: string;
    payload: {
        userName: string;
        userEmail: string;
        userFunction: number;
    };
}

const inviteUser = async ({ organizationId, payload }: IInviteParams) => {
    const resp = await axiosInstance.post(API_ENDPOINTS.INVITE_USER(organizationId), payload);
    return resp.data;
};

export const useInviteUserToOrganization = () => useMutation({ mutationFn: inviteUser });

export default useInviteUserToOrganization;
